import React from 'react';
import { useSelector } from 'react-redux';
import propTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import Typography from './Typography';
import validate from '../utils/label-validator';
import './Heading.scss';
import defaultPropValues from '../helper/defaultPropValues';

const Heading = (props) => {
	const data = { ...defaultPropValues.headingProps.data, ...props.data };
	const { id, title, subtitle, addHeadingBorderTop } = data;
	const { disableStickyHeader, disableShrinkHeader } = useSelector(
		(state) => state.headerSettings
	);
	const labels = useLabels();
	return (
		<div className="ws-content-rows-heading">
			<div
				id={id}
				className={`anchor ${
					disableStickyHeader ? '' : 'stickyHeader'
				} ${disableShrinkHeader ? 'shrinkDisabled' : ''}`}
			>
				<span style={{ display: 'none' }}>{id}</span>
			</div>
			<div
				aria-labelledby={id}
				className={`${
					addHeadingBorderTop && 'headingBorderTop'
				} text-center py-6 py-sm-0`}
			>
				{validate(title) && (
					<Typography
						className="section-heading"
						weight="normal"
						variant="h1"
						alignment="center"
					>
						{labels.getHTML(title)}
					</Typography>
				)}
				{validate(subtitle) && (
					<Typography
						className="section-sub-heading mt-0"
						variant="h3"
					>
						{labels.getHTML(subtitle)}
					</Typography>
				)}
			</div>
		</div>
	);
};

export const HeadingProps = {
	data: propTypes.shape({
		title: propTypes.string.isRequired,
		id: propTypes.string,
		addHeadingBorderTop: propTypes.bool,
		subtitle: propTypes.string
	}).isRequired
};

Heading.propTypes = HeadingProps;

export default Heading;
